<template>
    <div class="block-text">

        <b-button :id="buttonID" :variant="btn_variant" :class="buttonStyle" @click="doCopy">
            <i class="fa fa-clone"></i>
            <span v-if="btn_text != undefined">{{ btn_text }}</span>
            <span v-else>{{ $t('menu.copy') }}</span>
        </b-button>

        <b-tooltip v-if="show_tooltip" :target="buttonID" placement="top">
            <span v-if="tooltip_text != undefined">{{ tooltip_text }}</span>
            <span v-else>{{ $t('menu.copy_to_clipboard') }}</span>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    props: {
        copy_content: {
            type: [String, Number],
            default: '',
        },
        btn_variant: {
            type: String,
            default: 'warning',
        },
        btn_style: {
            type: String,
            default: ''
        },
        btn_text: {
            type: String,
            default: undefined,
        },
        tooltip_text: {
            type: String,
            default: undefined,
        },
        show_toastr: {
            type: Boolean,
            default: true,
        },
        show_tooltip: {
            type: Boolean,
            default: true,
        },
    },
    computed: {

        buttonID ()
        {
            return 'copy-button'
        },

        buttonStyle ()
        {
            let _class = 'btn'
            switch ( this.btn_style )
            {
                case 'small':   _class += ' small'; break;
                case 'big':     _class += ' big'; break;
                case undefined: break;
                default:        _class += ' ' + this.btn_style; break;
            }

            return _class
        },

    },
    methods: {

        doCopy ()
        {
            let Vue = this;

            // 使用 VueClipboard 可能會無法在 Bootstrap Modals 內使用
            let container = this.$refs.container
            this.$copyText( this.copy_content, container )
                .then( function (e)
                {
                    Vue.onCopy(e)
                }, function (e)
                {
                    Vue.onError(e)
                })

            // 所以加上另一種複製方式
            navigator.clipboard.writeText( this.copy_content )
        },

        onCopy (e)
        {
            if (this.show_toastr)
            {
                this.$toastr.i( this.$t('other.copied_to_clipboard') + '<br>' + e.text );
            }
        },

        onError (e)
        {
            if (this.show_toastr)
            {
                this.$toastr.w(this.$t('other.copied_to_clipboard_failed') + '<br>' + err.data.status + '<br>' + err.data.message );
            }
        },
    }
}
</script>

<style lang="scss" scoped>

    .small
    {
        font-size: 0.85rem;
        padding: 2px 5px;

        i
        {
            margin-right: 0px;
        }
    }
    .big
    {
        font-size: 1.2rem;
        padding: 8px 15px;
    }

</style>
